import React from 'react';
import { NavLink } from 'react-router-dom';
import { Nav } from 'react-bootstrap';

/**
 * @param {{ pages: Array<{ to: string, label: string, exact?: boolean }> }} props
 */
export default function AdminNav({ pages }) {
  return (
    <Nav className="flex-column mb-3" variant="pills">
      {pages.map(page => (
        <Nav.Link key={page.to} as={NavLink} to={page.to} exact={page.exact}>
          {page.label}
        </Nav.Link>
      ))}
    </Nav>
  );
}
